<template>
  <v-card flat class="conteneurLead">
    <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
      <v-btn icon @click="cancelDialog()"><v-icon class="white--text">close</v-icon></v-btn>
      <span class="title">{{ $t('statSuperv24')}} {{nameAgentComputed}}</span>
      <v-spacer></v-spacer>
    </v-card-title>

    <v-card-text>
      <v-flex xs12>
        <v-card class="mb-3" height="400px" v-if="loading">
          <v-card-text class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card v-if="!loading" class="mb-3" >
          <!-- <v-layout row>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              flat
              @click="exportAgentsChatsPie()"
            >
              {{ $t('exportInCsv') }}
              <v-icon color="primary" right>file_download</v-icon>
            </v-btn>
          </v-layout> -->
          <v-flex d-flex xs12>
            <v-layout row wrap>
              <v-flex d-flex md8>
                <v-flex xs12 >
                  <highcharts :options="agentOccupation"></highcharts>
                  <br>
                  <highcharts :options="agentStatus"></highcharts>
                  <br>
                  <highcharts :options="agentConnexions"></highcharts>
                  <br>
                  <v-flex d-flex sc12>
                    <v-flex d-flex xs12 md4 child-flex>
                      <span class="text-md-center">{{ $t('statSuperv25')}} : {{afficheTotalTempsChat}}</span>
                    </v-flex>
                    <v-flex d-flex xs12 md4 child-flex>
                      <span class="text-md-center">{{ $t('statSuperv26')}} : {{moyenChatMax}}</span>
                    </v-flex>
                    <v-flex d-flex xs12 md4 child-flex>
                      <span class="text-md-center">{{ $t('statSuperv27')}} : {{afficheTotalTempsMoyenChats}}</span>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex d-flex xs12 md4 child-flex>
                <v-flex xs12 class="text-md-center">
                  <p>{{ $t('statSuperv23')}}<strong>{{afficheTotalTempsRef}}</strong></p>
                  <highcharts :options="productivityAgent"></highcharts>
                  <!-- <p class="text-md-center">Temps total connecté : {{afficheTotalTempsConnexion}}</p>
                  <p class="text-md-center">Temps en production : {{afficheTotalTempsActivity}}</p>
                  <p class="text-md-center">Temps hors production : {{afficheTotalTempsHorsProd}}</p> -->
                  <span>{{ $t('connectionRate')}} : {{tauxProductivity1}} % ({{afficheTotalTempsConnexion}})</span><br />
                  <span>{{ $t('agentsActivity')}} : {{tauxProductivity2}} % ({{afficheTotalTempsPresence}})</span><br />
                  <span>{{ $t('agentsInactivity')}} : {{tauxProductivity3}} % ({{afficheTotalTempsHorsProd}})</span><br />
                  <highcharts :options="activityAgent"></highcharts>
                  <span class="text-md-center">{{ $t('statSuperv28')}} : ({{afficheTotalTempsPresence}})</span><br />
                  <span class="text-md-center">{{ $t('statSuperv29')}} : {{afficheTotalTempsBusy}}</span><br />
                  <span class="text-md-center">{{ $t('statSuperv30')}} : {{afficheTotalTempsPartielleActivity}}</span>
                  <!-- <p class="text-md-center">Temps cumulé en chat partielle : {{afficheTotalTempsPartielleChat}}</p> -->
                  <!-- <p class="text-md-center">total temps busy : {{tempsTotalBusy}}</p>
                  <p class="text-md-center">Total temps online : {{tempsTotalOnline}}</p> -->
                  <!-- <p>{{tauxBusy}}</p>
                  <p>{{tempsOccupationBusy}}</p>
                  <p>{{totalTempsConnexion}}</p> -->
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-card>
      </v-flex>
    </v-card-text>

    <!-- DIALOGUES EDITEUR LEAD-->
    <!-- DIALOGUES -->
    <v-dialog
      v-model="dialogChat"
      persistent
      min-width="640px"
      max-width="800px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card flat>
        <v-card-title class="primary white--text"  style="height: 52px; padding: 0px;">
          <v-btn icon @click="cancelDialogChat()"><v-icon class="white--text">close</v-icon></v-btn>
          <span class="title"><!-- chat #{{ chatDialog.id }} --></span>
        </v-card-title>
          <v-card-text :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 210px);' : ''" class="pa-0">
            <wz-histo-chats
              v-if="chatDialog.id"
              :params="'visId=' + chatDialog.id"
              :numChatsTotal="String(0)"
              chatHeight="100%"
              type="satisfaction"
              scroll
            ></wz-histo-chats>
          </v-card-text>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
// import momentTz from 'moment-timezone'
import 'moment-duration-format'
import { mapGetters } from 'vuex'
import json2csv from 'json2csv'

export default {
  props: {
    dataAgentSelected: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      // chats par agent
      loading: false,
      utcDecal: '',
      dialogChat: false,
      chatDialog: {},
      tempsPresence: 28800,
      totalJoursOuvres: 1, // nombre de jours travaille sur la période
      totalTempsConnexion: 0,
      totalTempsPresence: 0,
      totalTempsAllChats: 0, // temps total de chat
      tempsTotalOnline: 0, // temps total online en econdes
      tempsTotalBusy: 0, // temps total busy en secondes
      tempsOccupationBusy: 0, // pour confirmer si les chiffres collent
      moyenChatMax: 0, // moyen des chats max sur la durrée (au cas ou elle change en cours de durrée)
      tempsOccupationPartielle: 0, // occupation partielle, agent online en chat mais pas fullChat
      totalTempsChat: [0, 0, 0, 0],
      tauxProductivity1: 0,
      tauxProductivity2: 0,
      tauxProductivity3: 0,
      // options générales pour les graphiques
      optionsGraph: {
        chart: {
        },
        colors: [
          '#F44336', // red
          '#3F51B5', // indigo
          '#009688', // teal
          '#E91E63', // pink
          '#607D8B', // blue-grey
          '#9C27B0', // purple
          '#2196F3', // blue
          '#FF5722', // deep-orange
          '#795548', // brown
          '#4CAF50', // green
          '#8BC34A', // light-green
          '#673AB7', // deep-purple
          '#CDDC39', // lime
          '#03A9F4', // light-blue
          '#FFC107', // amber
          '#FF9800', // orange
          '#FFEB3B', // yellow
          '#00BCD4', // cyan
          '#9E9E9E'  // grey
        ],
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        plotOptions: {
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },

      // options pour le graphique des chats par agent
      // camembert
      agentOccupation: {
        chart: {
          type: 'xrange',
          // height: (9 / 16 * 100) + '%' // 16:9 ratio
          height: 200 // 16:9 ratio
        },
        colors: [
          this.dataAgentSelected.agentColor
        ],
        title: {
          text: this.$t('statSuperv39') + moment.parseZone((this.dataAgentSelected.dateStart * 1000)).format('LL')
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          maxPadding: 0.1,
          minorGridLineColor: '#f1f1f1',
          minorTickInterval: 'auto',
          min: ((this.dataAgentSelected.dateStart * 1000) + 21600000), // date de depart (00:00) + 6 h
          max: ((this.dataAgentSelected.dateEnd * 1000) - 7200000) // date de fin (23:59) - 3 h
        },
        yAxis: {
          title: {
            text: this.$t('statSuperv40')
          },
          categories: ['1', '2', '3', '4'],
          reversed: false
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            point: {
              events: {
                click: (e) => {
                  this.openDialogChat(e)
                  // console.log('openOccupation =>', e)
                  // console.log('id agent', this.series.userOptions.agentID)
                }
              }
            }
          }
        },
        tooltip: {
          crosshairs: true,
          // pointFormat: '{series.name}: <b>{point.visiteurId}</b><br/>',
          valueSuffix: ' cm',
          shared: true,
          useHTML: true,
          headerFormat: '<small style="color: {point.color}"><b>' + this.$t('statSuperv41') + '</b></small>',
          pointFormat: '<table><tr><td>' + this.$t('statSuperv42') + ' : </td><td><b>{point.debut}</b> ' + this.$t('statSuperv43') + ' <b>{point.fin}</b></tr>' +
              '<tr><td>' + this.$t('statSuperv44') + ' : </td><td><b>{point.visiteurId}</b></td></tr></table>',
          footerFormat: ''
        },
        series: []
      },

      // options pour le graphique des chats par agent
      agentConnexions: {
        chart: {
          type: 'xrange',
          height: 150 // 16:9 ratio
        },
        colors: [
          this.dataAgentSelected.agentColor
        ],
        title: {
          text: this.$t('statSuperv45') + moment.parseZone((this.dataAgentSelected.dateStart * 1000)).format('LL')
          // text: 'connexions  : ' + moment.duration((this.totalTempsConnexion / 60), 'minutes').format('h [h] m [min]')
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          maxPadding: 0.1,
          minorGridLineColor: '#f1f1f1',
          minorTickInterval: 'auto',
          min: ((this.dataAgentSelected.dateStart * 1000) + 21600000), // date de depart (00:00) + 6 h
          max: ((this.dataAgentSelected.dateEnd * 1000) - 7200000) // date de fin (23:59) - 3 h
        },
        yAxis: {
          title: {
            text: 'Connexion'
          },
          categories: ['1'],
          reversed: false
        },
        tooltip: {
          crosshairs: true,
          // pointFormat: '{series.name}: <b>{point.visiteurId}</b><br/>',
          valueSuffix: ' cm',
          shared: true,
          useHTML: true,
          headerFormat: '<small style="color: {series.color}"><b>Connexion</b></small><table>',
          pointFormat: '<tr><td>' + this.$t('statSuperv42') + ' : </td><td><b>{point.debut}</b></td></tr>' +
              '<tr><td>' + this.$t('statSuperv43') + ' : </td><td><b>{point.fin}</b></td></tr>',
          footerFormat: '</table>'
        },
        series: []
      },

      // options pour le graphique des chats par agent
      agentStatus: {
        chart: {
          type: 'xrange',
          height: 150 // 16:9 ratio
        },
        // colors: [
        //   this.dataAgentSelected.agentColor
        // ],
        title: {
          text: this.$t('statSuperv46') + moment.parseZone((this.dataAgentSelected.dateStart * 1000)).format('LL')
          // text: 'connexions  : ' + moment.duration((this.totalTempsConnexion / 60), 'minutes').format('h [h] m [min]')
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          maxPadding: 0.1,
          minorGridLineColor: '#f1f1f1',
          minorTickInterval: 'auto',
          // color
          min: ((this.dataAgentSelected.dateStart * 1000) + 21600000), // date de depart (00:00) + 6 h
          max: ((this.dataAgentSelected.dateEnd * 1000) - 7200000) // date de fin (23:59) - 3 h
        },
        yAxis: {
          title: {
            text: this.$t('statSuperv47')
          },
          categories: ['1'],
          reversed: false
        },
        tooltip: {
          crosshairs: true,
          // pointFormat: '{series.name}: <b>{point.visiteurId}</b><br/>',
          valueSuffix: ' cm',
          shared: true,
          useHTML: true,
          headerFormat: '<table>',
          pointFormat: '<tr><td colspan="2" style="color: {point.color}"><b>{point.status}</b></td></tr>' +
              '<tr><td>' + this.$t('statSuperv42') + ' : </td><td><b>{point.debut}</b></td></tr>' +
              '<tr><td>' + this.$t('statSuperv43') + ' : </td><td><b>{point.fin}</b></td></tr>',
          footerFormat: '</table>'
        },

        series: []
      },

      // graphique activité
      // camembert
      productivityAgent: {
        chart: {
          type: 'solidgauge',
          height: 300,
          events: {
            // render: this.renderGraph()
          }
        },

        title: {
          text: _.upperFirst(this.$t('productivity'))
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div><div style="font-size:0.7em; text-align: center; width:100%">{series.name}</div><br><div style="font-size:1.5em; color: {point.color}; font-weight: bold; text-align: center; width:100%">{point.y}%</div></div>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: (this.chart.plotHeight / 2) + 15
            }
          }
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
            outerRadius: '112%',
            innerRadius: '88%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#3F51B5')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Exercise
            outerRadius: '87%',
            innerRadius: '63%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#8BC34A')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Stand
            outerRadius: '62%',
            innerRadius: '38%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#9E9E9E')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: _.upperFirst(this.$t('presence')),
          data: [{
            color: '#3F51B5',
            // color: this.Highcharts.getOptions().colors[0],
            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: _.upperFirst(this.$t('emojiActivity')),
          data: [{
            color: '#8BC34A',
            // color: this.Highcharts.getOptions().colors[1],
            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: _.upperFirst(this.$t('inactivity')),
          data: [{
            color: '#9E9E9E',
            // color: this.Highcharts.getOptions().colors[2],
            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      },

      // graphique activité
      // camembert
      activityAgent: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: 300,
          type: 'pie'
        },
        title: {
          text: _.upperFirst(this.$t('advisorOccupancy'))
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            point: {
              events: {
// ------------------------------------------------------------------------
// momentanement commenté pour ne pas avoir acces au stats
                // click: (e) => {
                //   this.openOccupation(e)
                  // console.log('date', this.category)
                  // console.log('id agent', this.series.userOptions.agentID)
                // }
// ------------------------------------------------------------------------
              }
            },
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: []
      }
    }
  },

  created () {
    console.log('created vue')
    console.log('Date.UTC(2010, 0, 1, 0, 0, 0)', Date.UTC(2010, 0, 1, 0, 0, 0))
    console.log('this.dataAgentSelected.dateStart', this.dataAgentSelected.dateStart)
    console.log('this.dataAgentSelected.dateEnd', this.dataAgentSelected.dateEnd)
    this.tempsPresence = ((this.dataAgentSelected.tempsTravail * 60) * 60) // heures en secondes
    console.log('tempsPresence', this.dataAgentSelected)
    // affichage des loaders
    // this.loadingAgentsChats = true
    // this.loadingAgentsActivity = true
    // initialisation des options liées aux graphiques
    this.agentOccupation = _.merge(this.agentOccupation, this.optionsGraph)
    this.agentConnexions = _.merge(this.agentConnexions, this.optionsGraph)
    this.agentStatus = _.merge(this.agentStatus, this.optionsGraph)
    this.productivityAgent = _.merge(this.productivityAgent, this.optionsGraph)
    this.activityAgent = _.merge(this.activityAgent, this.optionsGraph)
    // this.getAll()
    // const _self = this
  },

  mounted () {
    this.loading = true
    let dateNow = Date.now()
    let inverseOffset = moment(dateNow).utcOffset()
    console.log('inverseOffset', inverseOffset)
    this.utcDecal = inverseOffset
    // console.log('mounted vue')
    console.log('dataAgentSelected', this.dataAgentSelected)
    this.getOccupation()
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    agentsChatsPieComputed () {
      let res = []
      _.each(this.agentOccupation.series[0].data, a => {
        let name = a.name.split(' (')[0]
        let chats = a.name.split(' (')[1].split(' ')[0]
        res.push({
          name: name,
          y: a.y,
          chats: chats
        })
      })
      return res
    },
    dataAgentComputed () {
      return this.dataAgentSelected
    },
    nameAgentComputed () {
      return this.dataAgentSelected.agentName
    },
    // Calcule des données pour les stats occupation  agent
    // affiche le temps total connecté au bo
    afficheTotalTempsConnexion () {
      return moment.duration((this.totalTempsConnexion / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps total full chat
    afficheTotalTempsBusy () {
      return moment.duration((this.tempsTotalBusy / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps total en activité
    afficheTotalTempsActivity () {
      // temps online + occupé
      let tempsActivity = (this.tempsTotalBusy + this.tempsTotalOnline)
      if (tempsActivity > this.afficheTotalTempsConnexion) {
        tempsActivity = this.afficheTotalTempsConnexion
      }
      return moment.duration((tempsActivity / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps de presence agent (online + busy)
    afficheTotalTempsPresence () {
      let tempsPresence = this.totalTempsPresence
      return moment.duration((tempsPresence / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps total en activité partiel
    afficheTotalTempsPartielleActivity () {
      return moment.duration((this.tempsTotalOnline / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps myen en chat
    // la moyen de chatMax est calculé sur la période selectionnée
    // (il est possible que l'agent change ce nombre de chatMax en cours de période)
    afficheTotalTempsMoyenChats () {
      let tempsChatMoyen = ((this.totalTempsAllChats / 1000) / this.moyenChatMax)
      return moment.duration((tempsChatMoyen / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps total en chat
    afficheTotalTempsChat () {
      let tempsChatMoyen = (this.totalTempsAllChats / 1000)
      return moment.duration((tempsChatMoyen / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps hors production
    afficheTotalTempsHorsProd () {
      let tempsHorsProd = (this.totalTempsConnexion - (this.tempsTotalBusy + this.tempsTotalOnline))
      return moment.duration((tempsHorsProd / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps partielle en chat
    afficheTotalTempsPartielleChat () {
      let tempsChatPartielle = (this.tempsOccupationPartielle / 1000)
      return moment.duration((tempsChatPartielle / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps busy 2 pour confirmation
    afficheTotalTempsBusyChat () {
      let tempsChatBusy = (this.tempsOccupationBusy / 1000)
      return moment.duration((tempsChatBusy / 60), 'minutes').format('h [h] m [min]')
    },
    // Calcule le taux d'occupation busy
    tauxBusy () {
      return ((this.tempsOccupationBusy / 1000) * 100) / this.totalTempsConnexion
    },
    // Calcule le taux d'occupation partirel, 1chat mini et pas au max des chat
    tauxOccupationPartiel () {
      return ((this.tempsOccupationPartielle / 1000) * 100) / this.totalTempsConnexion
    },
    // Calcule le taux d'inoccupation pas en chat et online
    // le temps de presence agent (online + busy) - (temps partiel en chat + temps busy)
    tauxInoccupation () {
      let inoccuper = this.totalTempsPresence - ((this.tempsTotalBusy + this.tempsOccupationPartielle) / 1000)
      // let inoccuper = (this.totalTempsConnexion - (this.tempsOccupationPartielle + this.tempsOccupationBusy))
      return ((inoccuper) * 100) / this.totalTempsConnexion
    },
    // affiche le temps de reference pour la période
    afficheTotalTempsRef () {
      let tempsRef = (this.tempsPresence * this.totalJoursOuvres)
      return moment.duration((tempsRef / 60), 'minutes').format('h [h] m [min]')
    }
  },

  methods: {
    getOccupation () {
      this.agentOccupation.series.push({'data': []})
      let param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) +
        '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) +
        '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID)
      this.axios.get('get/occupationAgentDay.php?' + param)
      .then(response => {
        console.log('getOccupation:response : ', response.data)
        let limiteChat = 0
        // Attention toutes les date ajax sont en UTC 0
        // Maj des colonnes stackées (data par jour)
        _.each(response.data, (values, key) => {
          // pour calculer le nombre chatMax sur la période
          limiteChat = limiteChat + values.chatMax
          // ajout des jours dans l'axe des X
          values.y = (values.y - 1)
          // temps total des chats
          this.totalTempsAllChats = this.totalTempsAllChats + (values.x2 - values.x)
          // temps de chat pour chaque place
          this.totalTempsChat[(values.y - 1)] = Math.round(this.totalTempsChat[(values.y - 1)]) + Math.round((values.x2 / 1000) - (values.x / 1000))
          // convertion des dates sur le bon timeZone
          let dateS = values.x + (this.utcDecal * 60000)
          let dateE = values.x2 + (this.utcDecal * 60000)
          // dates pour le tooltips
          values.debut = moment.utc(dateS).format('LTS')
          values.fin = moment.utc(dateE).format('LTS')
          // dates pour le graphique
          values.x = dateS
          values.x2 = dateE
          values.color = this.optionsGraph.colors[13]
          // ajoute les données finales
          this.agentOccupation.series[0].data.push(values)
          // pour calculer le temps partielle en chat, minimum 1 chat en cours et pas au max
          if (values.numChat && values.numChat < values.chatMax) {
            // console.log('values.numChat', values.numChat)
            this.tempsOccupationPartielle = this.tempsOccupationPartielle + (values.x2 - values.x)
          }
          // pour calculer le temps busy
          if (values.numChat && values.numChat >= values.chatMax) {
            this.tempsOccupationBusy = this.tempsOccupationBusy + (values.x2 - values.x)
          }
        })
        console.log('this.tempsOccupationPartielle', this.tempsOccupationPartielle)
        // calcule la moyen de chatMax sur cette période (l'agent peut avoir changé ce nombre en cours de période)
        this.moyenChatMax = Math.round(limiteChat / response.data.length) // moyen des chatMax
        // console.log('moyenChatMax', this.moyenChatMax)
        this.agentOccupation.series[0].name = this.$t('statSuperv48')
        this.agentOccupation.series[0].dataLabels = {enabled: false}
        console.log('this.agentOccupation : ', this.agentOccupation)
      })
      .catch()
      .then(_ => {
        // this.loading = false
        this.getConnexions()
        // this.occupationAgentDay = true
      })
    },

    /**
     * lance toutes les requêtes
     */
    getConnexions () {
      this.agentConnexions.series.push({'data': []})
      let param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) +
        '&refTime=' + encodeURIComponent(this.tempsPresence) +
        '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) +
        '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID)
      this.axios.get('get/connexionAgentDay.php?' + param)
      .then(response => {
        // console.log('response getConnexions : ', response)
        // Attention toutes les date ajax sont en UTC 0
        // Maj des colonnes stockées (data par jour)
        if (response.data.connexions) {
          for (let index = 0; index < response.data.connexions.length; index++) {
            let values = response.data.connexions[index]
            let previousValues = response.data.connexions[(index - 1)]

            // verificartion si pas multisession
            if (values.type !== 8) {
              // c'est la ligne qui suit une multisession on ne l'ajoute pas au tableau
              if (previousValues && previousValues.type !== 8) {
                // total temps de connexion uniquement si la valeur est validé ou active
                // cas d'une deconnexion forcé
                if (values.x2 > values.x) {
                  this.totalTempsConnexion = this.totalTempsConnexion + (values.x2 - values.x)
                  // ajout des jours dans l'axe des X
                  values.y = (values.y - 1)
                  // convertion des dates sur le bon timeZone
                  let dateS = (values.x * 1000) + (this.utcDecal * 60000)
                  let dateE = (values.x2 * 1000) + (this.utcDecal * 60000)
                  // console.log('dateS', dateS)
                  // dates pour le tooltips
                  values.debut = moment.utc(dateS).format('LTS')
                  values.fin = moment.utc(dateE).format('LTS')
                  // console.log('values.debut', values.debut)
                  // dates pour le graphique
                  values.x = dateS
                  values.x2 = dateE
                  // ajoute les données finales
                  this.agentConnexions.series[0].data.push(values)
                }
              }
              // si c'est le premier et c'est pas du type 8 on ajoute
              if (index === 0) {
                // uniquement si la valeur x2 plus grande que x
                if (values.x2 > values.x) {
                  // total temps de connexion
                  this.totalTempsConnexion = this.totalTempsConnexion + (values.x2 - values.x)
                  // ajout des jours dans l'axe des X
                  values.y = (values.y - 1)
                  // convertion des dates sur le bon timeZone
                  let dateS = (values.x * 1000) + (this.utcDecal * 60000)
                  let dateE = (values.x2 * 1000) + (this.utcDecal * 60000)
                  // console.log('dateS', dateS)
                  // dates pour le tooltips
                  values.debut = moment.utc(dateS).format('LTS')
                  values.fin = moment.utc(dateE).format('LTS')
                  // console.log('values.debut', values.debut)
                  // dates pour le graphique
                  values.x = dateS
                  values.x2 = dateE
                  // ajoute les données finales
                  this.agentConnexions.series[0].data.push(values)
                }
              }
            }
            // this.agentOccupation.series[0].data.push(values)
          }
          this.agentConnexions.series[0].name = _.upperFirst(this.$t('connections'))
          this.agentConnexions.series[0].dataLabels = {enabled: false}
          this.agentConnexions.series[0].color = this.optionsGraph.colors[4]
          this.agentConnexions.series[0].total = this.totalTempsConnexion
          // console.log('this.agentConnexions : ', this.agentConnexions)
        }
      })
      .catch()
      .then(_ => {
        // this.loading = false
        // this.occupationAgentDay = true
        // charge les status agent
        this.getStatusAgent()
      })
    },

    /**
     * lance la requête statusAgentDay
     */
    getStatusAgent () {
      this.agentStatus.series.push({'data': []})
      let param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) +
        '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) +
        '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID)
      this.axios.get('get/statusAgentDay.php?' + param)
      .then(response => {
        // console.log('response : ', response)
        // Attention toutes les date ajax sont en UTC 0
        // Maj des colonnes stackées (data par jour)
        for (let index = 0; index < response.data.length; index++) {
          let values = response.data[index]
          let previousValues = response.data[(index - 1)]
          if (values.status === 'online') {
            values.color = '#4CAF50'
          } else if (values.status === 'busy') {
            values.color = '#FF9800'
          } else if (values.status === 'offline') {
            values.color = '#F44336'
          } else {
            values.color = 'rgba(244, 67, 54, 0.1)'
          }

          // uniquement si different de offline
          if (values.status !== 'deconnect') {
            // c'est la ligne qui suit une multisession on ne l'ajoute pas au tableau
            if (previousValues) {
              // total temps de connexion
              this.totalTempsPresence = this.totalTempsPresence + (values.x2 - values.x)
              // ajout des jours dans l'axe des X
              values.y = (values.y - 1)
              // convertion des dates sur le bon timeZone
              let dateS = (values.x * 1000) + (this.utcDecal * 60000)
              let dateE = (values.x2 * 1000) + (this.utcDecal * 60000)
              // console.log('dateS', dateS)
              // dates pour le tooltips
              values.debut = moment.utc(dateS).format('LTS')
              values.fin = moment.utc(dateE).format('LTS')
              // console.log('values.debut', values.debut)
              // dates pour le graphique
              values.x = dateS
              values.x2 = dateE
              // temps entre les 2 valeurs
              let diffTimestamp = (values.x2 - values.x) / 1000
              // ajoute les données finales
              this.agentStatus.series[0].data.push(values)
              // calcule le temps passé online
              if (values.status === 'online') {
                // console.log('a1 - ', this.tempsTotalOnline + ' - ' + diffTimestamp)
                this.tempsTotalOnline = this.tempsTotalOnline + diffTimestamp
                // console.log('b1 - ', this.tempsTotalOnline)
              }
              // calcule le temps passé occupé
              if (values.status === 'busy') {
                this.tempsTotalBusy = this.tempsTotalBusy + diffTimestamp
              }
            }
            // si c'est le premier et c'est pas du type 8 on ajoute
            if (index === 0) {
              // total temps de connexion
              this.totalTempsPresence = this.totalTempsPresence + (values.x2 - values.x)
              // ajout des jours dans l'axe des X
              values.y = (values.y - 1)
              // convertion des dates sur le bon timeZone
              let dateS = (values.x * 1000) + (this.utcDecal * 60000)
              let dateE = (values.x2 * 1000) + (this.utcDecal * 60000)
              // console.log('dateS', dateS)
              // dates pour le tooltips
              values.debut = moment.utc(dateS).format('LTS')
              values.fin = moment.utc(dateE).format('LTS')
              // console.log('values.debut', values.debut)
              // dates pour le graphique
              values.x = dateS
              values.x2 = dateE
              // temps entre les 2 valeurs
              let diffTimestamp = (values.x2 - values.x) / 1000
              // ajoute les données finales
              this.agentStatus.series[0].data.push(values)
              // calcule le temps passé online
              if (values.status === 'online') {
                this.tempsTotalOnline = this.tempsTotalOnline + diffTimestamp
                // console.log('0 - ', this.tempsTotalOnline)
              }
              // calcule le temps passé occupé
              if (values.status === 'busy') {
                this.tempsTotalBusy = this.tempsTotalBusy + diffTimestamp
              }
            }
          }
          // this.agentOccupation.series[0].data.push(values)
        }
        this.agentStatus.series[0].name = _.upperFirst(this.$t('presence'))
        this.agentStatus.series[0].dataLabels = {enabled: false}
        this.agentStatus.series[0].color = this.optionsGraph.colors[4]
        this.agentStatus.series[0].total = this.totalTempsPresence
        // console.log('this.agentStatus : ', this.agentStatus)
        // console.log('tempsTotalOnline', this.tempsTotalOnline)
        // console.log('tempsTotalBusy', this.tempsTotalBusy)
        // calcule l'activité en poucentage
        // % de presence
        let presence = (this.totalTempsConnexion * 100) / (this.tempsPresence * this.totalJoursOuvres)
        this.tauxProductivity1 = presence.toFixed(2)
        this.productivityAgent.series[0].data[0].y = Math.round(presence * 100) / 100
        // % d'activité chat
        // il faut diviser ce nombre par le nombre de chat max dispo pour cet agent
        let totalActivityTime = (this.tempsTotalBusy + this.tempsTotalOnline)
        let totalChats = (totalActivityTime * 100) / (this.tempsPresence * this.totalJoursOuvres)
        this.tauxProductivity2 = totalChats.toFixed(2)
        this.productivityAgent.series[1].data[0].y = Math.round(totalChats * 100) / 100
        // let totalChats = ((this.totalTempsAllChats / 1000) * 100) / this.totalTempsConnexion
        // this.productivityAgent.series[1].data[0].y = Math.round(totalChats)
        // % d'inactivité
        let inactiv = ((this.totalTempsConnexion - totalActivityTime) * 100) / (this.tempsPresence * this.totalJoursOuvres)
        this.tauxProductivity3 = inactiv.toFixed(2)
        this.productivityAgent.series[2].data[0].y = Math.round(inactiv * 100) / 100
        // let inactiv = ((this.totalTempsConnexion - (this.totalTempsAllChats / 1000)) * 100) / this.tempsPresence
        // this.productivityAgent.series[2].data[0].y = Math.round(inactiv)
        // console.log('this.productivityAgent', this.totalTempsConnexion + '-' + this.totalTempsAllChats)

        let dataOccupation = [
          {
            name: _.upperFirst(this.$t('partialOccupation')),
            color: this.optionsGraph.colors[9],
            y: this.tauxOccupationPartiel
          },
          {
            name: _.upperFirst(this.$t('maximumOccupancy')),
            color: this.optionsGraph.colors[15],
            y: this.tauxBusy
          },
          {
            name: _.upperFirst(this.$t('unoccupied')),
            color: this.optionsGraph.colors[10],
            y: this.tauxInoccupation
          }
        ]
        // console.log('dataOccupation', dataOccupation)
        this.activityAgent.series = [{}]
        this.activityAgent.series[0].data = []
        // this.activityAgent.series[0].data[0] = dataOccupation
        this.activityAgent.series[0].data = dataOccupation
      })
      .catch()
      .then(_ => {
        this.loading = false
        // this.occupationAgentDay = true
        // charge les status agent
        // this.getStatusAGent()
      })
    },

    /**
     * lance toutes les requêtes
     */
    getAll () {
      this.getAgentsChats()
    },

    /**
     * Close dialogue occupation
     */
    cancelDialog () {
      // this.dialogEdit = false
      this.$emit('closeDialog')
    },

    /**
     * Dialogue d'édition d'un lead
     */
    openDialogChat (data) {
      // console.log('dsata', data)
      let index = data.point.index
      this.dialogChat = true
      this.chatDialog = {}
      let dataChat = {
        'date': String(Math.round(data.point.series.userOptions.data[index].x / 1000)),
        'id': data.point.series.userOptions.data[index].visiteurId,
        'site': '',
        'agent': {
          USR_ID: String(this.dataAgentSelected.agentID),
          USR_MAIL: '',
          USR_MAIL_CONTACT: '',
          USR_FIRST_NAME: this.dataAgentSelected.agentName,
          USR_LAST_NAME: ''
        }
      }
      // console.log('dataChat', dataChat)
      this.chatDialog = _.clone(dataChat)
    },
    cancelDialogChat () {
      this.dialogChat = false
    },

    /**
     * Récupère les chats par agents
     */
    getAgentsChats () {
      this.loadingAgentsChats = true
      this.axios.get('get/agents_chats.php?' + this.params)
      .then(response => {
        // mise à jour du graphique avec les données récupérées
        // reset des data du graphique
        this.agentsChatsPie.series = [{}]
        this.agentsChatsPie.series[0].data = []
        this.agentsChatsBar.series = []
        this.agentsChatsBar.xAxis.categories = []
        // Maj du camembert (part des chats/agent)
        // et ajout des series pour les agents du graph colonnes
        let idAgents = []
        let nbChats = 0
        response.data.chatsByAgent.forEach(agent => {
          // change l'id par le nom de l'agent parmis les agents sélectionné
          let agentFound = _.find(this.$store.state._User.colleagues, {'USR_ID': _.toString(agent.id)})
          this.agentsChatsPie.series[0].data.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME + ' (' + agent.nb + ' chats)',
            y: agent.pourcent
          })
          // incrémentation du nombre de chat totaux
          nbChats += agent.nb
          idAgents.push(agent.id)
          this.agentsChatsBar.series.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            day: response.data.days,
            arrayDays: response.data.arrayDays,
            data: []
          })
        })
        // Maj du titre indiquant le total de chats
        this.agentsChatsPie.title.text = _.upperFirst(this.$tc('distributionOfChats', 1, {count: nbChats}))
        // Maj des colonnes stackées (data par jour)
        // pour chaque jour
        Object.entries(response.data.days).forEach(([date, agents]) => {
          // ajout des jours dans l'axe des X
          this.agentsChatsBar.xAxis.categories.push(moment(date).format('ll'))
          // ajout des données dans l'axe des Y
          // pour chaque agent
          Object.entries(agents).forEach(([id, chat]) => {
            let idx = idAgents.findIndex(i => i === _.toNumber(id))
            if (idx !== -1 && this.agentsChatsBar.series[idx]) {
              this.agentsChatsBar.series[idx].data.push(chat)
            }
          })
        })
        console.log('this.agentsChatsBar', this.agentsChatsBar)
      })
      .catch()
      .then(_ => {
        this.loadingAgentsChats = false
      })
    },

    exportAgentsChatsPie () {
      let csv = ''
      let data = []
      let fields = []
      let fieldNames = ['agent', 'chats', 'pourcentage']
      fields = ['name', 'chats', 'y']
      data = this.agentsChatsPieComputed
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsChatsPie.csv', csv)
    },

    downloadFile (filename, content) {
      let hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(content)
      hiddenElement.target = '_blank'
      hiddenElement.download = filename
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    }
  },

  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzAgentsOccupationDay.vue